// removed by extract-text-webpack-plugin
    if(module.hot) {
      // 1639415928467
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  


//////////////////
// WEBPACK FOOTER
// ./src/components/ParadigmaAsyncSeeker/scss/default.scss
// module id = ./src/components/ParadigmaAsyncSeeker/scss/default.scss
// module chunks = 0